import './../global.js'
import Parse from 'parse';
import React from 'react';
import SinglePost from "./../singlepost.jsx";
import { Route, Link} from "react-router-dom";
import Leftsidebar from "../Leftsidebar.jsx";
import $ from "jquery";
import CommonPopup from '../CommonPopup.jsx';
import SaveNotification from "../saveNotification.jsx";

class Myprofiles extends React.Component {
      constructor(props) {
        super(props);

        let currentUser = Parse.User.current();   
        
        if(!currentUser)
        {
            window.location.href = "/";
        }
        //let displayUsername = currentUser.get("displayUsername");

        let displayUsername='';
        if(currentUser)
        {
           displayUsername = currentUser.get("displayUsername");
        }

        Parse.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5", "sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw"); //PASTE HERE YOUR Back4App APPLICATION ID AND YOUR JavaScript KEY
        Parse.serverURL = "https://parse.joelskitchen.com/parse";
        //Parse.serverURL = "https://parsetest.joelskitchen.com/parse";

        var now = new Date();
        let getLoggedinUsername=localStorage.getItem('username');
        
        this.state = {
            usernameParam: 0,
            userData: null,
            created_at: now.getTime(),
            comments: null,
            userImage: null,
            user: null,
            caption: null,
            likeCount: 0,
            saveCount: 0,
            commentCount: 0,
            posts: {},
            width: 0,
            height: 0,
            getLoggedinUsername:getLoggedinUsername,
            saveposts: {},
            recipeposts: {},
            postsCount: 0,
            followingCount: 0,
            followersCount: 0,
            followersListing: {},
            followingImages: {},
            challenges:{},
            followinguserid:[],
            searchTerm: '',
            searchfollowersListing: {},
            searchfollowingListing: {},
            followersCountPopup: 0,
            followingCountPopup: 0,
            isPopupOpen: false,
            post_common_id:'',
            isNotificationOpen:false,
            post_Notification_Id:'',
            post_Notification_Msg:'',
            post_Notification_Comment:'',
            streamtabValue: 'posts',
            streampagepath:'my-profile'
        };


        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);


        //this.setState({usernameParam: this.props.match.params.id});
        //this.setState({usernameParam: displayUsername});

        //this.usernameParam = this.props.match.params.id;
        this.usernameParam = displayUsername;
        //this.state.userData.get("website")
        this.queryForUserData();
        this.checktabActive = this.checktabActive.bind(this);
        this.handleUnFollowMyProfile = this.handleUnFollowMyProfile.bind(this);
        this.handleFollowMyProfile = this.handleFollowMyProfile.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        localStorage.setItem('storestreamtabValue', 'posts');
        localStorage.setItem('storestreampagepath', 'my-profile');
       

    }
 toggleNotification = (postid,msg,comment) => {   //console.log('toggleNotification'+postid);
      var self = this;
        self.setState(prevState => ({
          isNotificationOpen: !prevState.isNotificationOpen,
          post_Notification_Id: postid,
          post_Notification_Msg: msg,
          post_Notification_Comment:comment  
        }));
        //self.setState({ post_Notification_Id: postid });        
      };
  handleSearch = (event) => {
        const searchTerm = event.target.value;
        let followersListings=this.state.followersListing;
        let searchfollowersListing=this.state.searchfollowersListing;
        
        const followersListing = searchfollowersListing.filter(item =>

          item.displayName.toLowerCase().includes(searchTerm.toLowerCase())
          //item.get('fromUser').get('displayUsername').toLowerCase().includes(searchTerm.toLowerCase())
       
        );

        this.setState({searchTerm: searchTerm});
        this.setState({followersListing: followersListing});
        this.setState({followersCountPopup: followersListing.length});


        //followingImages1
        let followingListings=this.state.followingImages;
        let searchfollowingListing=this.state.searchfollowingListing;

        const followingListing = searchfollowingListing.filter(item =>
           item.displayName.toLowerCase().includes(searchTerm.toLowerCase())
          // item.displayUsername.toLowerCase().includes(searchTerm.toLowerCase())
        
        );
        this.setState({followingImages: followingListing});
        this.setState({followingCountPopup: followingListing.length});
        
        //searchfollowingListing
        if(searchTerm==='')
        {
           this.queryGetFollowersFollowing(); 
        }    
  };
    handleFollowMyProfile = (e) => {

        let datapost_id=e.target.dataset.id;
        const currentUser = Parse.User.current();
        if(currentUser) {
            var self = this;
            var query = new Parse.Query('User');
            query.equalTo("objectId", datapost_id);
            query.first().then(function(result){
               if(result)
               {
                    let touser=result;
                    //var Activity = Parse.Object.extend("Activity");
                    //var activity = new Activity();
                    //activity.equalTo('fromUser', "_User$"+datapost_id);
                    //activity.set('toUser', touser);    
                    //activity.equalTo('toUser', "_User$"+datapost_id);    
                    //activity.equalTo('toUser', "_User$"+currentUser.id);         
                   // activity.equalTo('type', 'follow');    
                    var Activity = Parse.Object.extend("Activity");
                    var activity = new Activity();
                    activity.set('fromUser', currentUser);
                    activity.set('toUser', touser);              
                    activity.set('type', 'follow'); 
                    activity.save().then((savedFile) => {
                    setTimeout(() => {
                             $('a.unfollowpost_link#follow_'+datapost_id).attr("style", "display: block");
                             $('a.followpost_link#follow_'+datapost_id).attr("style", "display: none");
                             },500);
                         self.toggleNotification(touser,'started following you.','');
                         self.setState({isNotificationOpen:false,post_Notification_Id:'',post_Notification_Msg:'',post_Notification_Comment:''}); 

                      /*setTimeout(() => {
                         this.queryGetFollowersFollowing();
                      },500);*/
                }).catch((error) => {
                });              
               }
            })
            setTimeout(() => {
                         this.queryGetFollowersFollowing();
                       
                      },1000);
        }else
        {
            // $('#kitchenQrModal_btn').trigger('click');  
            return false;
        }

    }
    handleUnFollowMyProfile= (e) => {
     let datapost_id=e.target.dataset.id;
        const currentUser = Parse.User.current();
        if(currentUser) {
            var query = new Parse.Query('User');
            query.equalTo("objectId", datapost_id);
            query.first().then(function(result){
               if(result)
               {
                let touser=result;
                var checksavequery = new Parse.Query('Activity');  
                checksavequery.equalTo('type', 'follow'); 
                checksavequery.equalTo('toUser', "_User$"+datapost_id);
                checksavequery.equalTo('fromUser',currentUser);
                checksavequery.first()
                              .then((object) => {
                                if (object) {
                                    //console.log(object);
                                  return object.destroy();
                                } 
                              })
                              .then((deletedObject) => {
                                    //$('#follwerModal a.followpost_linkpopup#followpopup_'+touser.id).attr("style", "display: block");
                                    //$('#follwerModal a.unfollowpost_linkpopup#followpopup_'+touser.id).attr("style", "display: none");
                              })
                              .catch((error) => {
                                console.error('Error deleting record:', error);
                              });  
               }
           })
             setTimeout(() => {
                        this.queryGetFollowersFollowing();
                       },2000);
        }else
        {
            // $('#kitchenQrModal_btn').trigger('click');  
            return false;
        }


    }

    checktabActive = function(e){ 
        $('.modal-backdrop').remove();
         let activetab=e.target.dataset.id;
         if(activetab==='#usrFlwrsTabs')
         {
              $('#follwerModal li.nav-item a.nav-link#usrFlwrsTabs').addClass('active show');
              $('#follwerModal li.nav-item a.nav-link#usrFlwingTabs').removeClass('active show');
              $('#follwerModal #usrfollwerPanel #usrFlwrsPane').addClass('active show');
              $('#follwerModal #usrfollwerPanel #usrFlwingPane').removeClass('active show');
         }
         if(activetab==='#usrFlwingTabs')
         {
              $('#follwerModal li.nav-item a.nav-link#usrFlwingTabs').addClass('active show');
              $('#follwerModal li.nav-item a.nav-link#usrFlwrsTabs').removeClass('active show');
              $('#follwerModal #usrfollwerPanel #usrFlwrsPane').removeClass('active show');
              $('#follwerModal #usrfollwerPanel #usrFlwingPane').addClass('active show');
         } 
    }


    componentDidMount() {
      this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);

    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
      this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    queryForPosts() {

        var query = new Parse.Query('Photo');
        
        query.include("user");
        query.include("image");
        query.include("thumbnail");
        query.include("likeCountNew");
        query.include("saveCount");
        query.include("commentcount");
        query.include("_created_at");
        query.include("createdAt");
        query.exists("user");
        query.exists("image");//added
        query.exists("thumbnail");//added
        query.doesNotExist("isChallenge");//added
        query.descending("createdAt");
        query.limit(99999999999999999999999999);
        query.equalTo("user", this.state.userData);
        var self = this;

        query.find().then(function(result){
            if(result){
                
                self.setState({posts: result});
                let resultcount=result.length;
                if(resultcount!==undefined)
                {
                    self.setState({postsCount: resultcount});
                }
            } else {
                console.log("No post found");
               // promise.resolve(null);
            }
        }, function(error){
                console.error("Error loading post Error: " + error);
                //promise.error(error);
        });
         
    }

    queryForPostsRecipe() {
        /*var query = new Parse.Query('User');      
        query.equalTo("displayUsername", 'ben_dev');
        query.include("user");
        var self = this;    
        query.first().then(function(user){
            if(user){ 
              var getRecipequery = new Parse.Query('Photo');  
                  getRecipequery.exists('recipeV2');
                  getRecipequery.equalTo('user',user);
                  getRecipequery.find().then(function(recipe){
                  if(recipe)
                  {          
                    self.setState({recipeposts: recipe});
                  }
                 })            
                }
        })*/
     let currentUser = Parse.User.current();
        var self = this;   
        if(currentUser)
        {
             var getRecipequery = new Parse.Query('Photo');  
             // getRecipequery.exists('recipeV2');
              getRecipequery.exists('isRecipe');
              getRecipequery.equalTo('user',currentUser);
              getRecipequery.doesNotExist("isChallenge");
              getRecipequery.descending("_created_at");
              getRecipequery.find().then(function(recipe){
              if(recipe)
              {          
                  self.setState({recipeposts: recipe});
              }
             })          
        }
    }
    queryForChallenges()
    {
        let currentUser = Parse.User.current();
        var self = this;   
        if(currentUser)
        {
              var getChallengequery = new Parse.Query('Photo');  
              getChallengequery.exists('isChallengeWinner');
              //getChallengequery.exists('isChallengeEntry');
              getChallengequery.include('isChallengeWinner');
              getChallengequery.equalTo('isChallengeWinner',true);
              getChallengequery.equalTo('user',currentUser);
              getChallengequery.find().then(function(challenge){
              if(challenge)
              {     
                  self.setState({challenges: challenge});
              }
             })          
        }

    }

     queryForPostsSave() {
        let currentUser = Parse.User.current();
        var self = this;   
        if(currentUser)
        { 
         
        /*const Save = Parse.Object.extend('Save');
        const query = new Parse.Query(Save);
      
        query.equalTo("fromUser","_User$"+currentUser.id);
        query.include('Photo');*/
        //let savequerydata=[];
   
        /*query.find().then(function(resultSave){
                 if(resultSave)
                 {
                      resultSave.forEach(results => {
                          var photodata = new Parse.Query('Photo');  
                              photodata.equalTo('objectId',results.get('photo').id);
                              photodata.find().then(function(photos){

                              if(photos[0]!=undefined)
                              {    
                                   savequerydata.push(photos[0]);
                              }
                             })
                      })
                    self.setState({saveposts: savequerydata});
                    
                    console.log(savequerydata);
                 }
             }) */ 

       /*new code*/  

        const Save = Parse.Object.extend('Save');
        const query = new Parse.Query(Save);
        // query1.equalTo("fromUser","_User$"+currentUser.id);
        query.equalTo("fromUser", "_User$"+currentUser.id);
        query.exists('photo');
        query.include('photo');
        query.include("image");
        query.doesNotExist("isChallenge");//added
       /* query.include('photo');
        query.select("photo.image");
        query.select("photo.isChallengeWinner");
        query.select("photo.isChallengeEntry");
        query.select("photo.isRecipe");*/

        query.descending("_created_at");
               
        var self = this;    
        query.find().then(function(results){
            if(results)
            { 
               self.setState({saveposts: results});  
            }
        })
         /*new code*/ 
        }
     }
     queryGetFollowersFollowing()
     {
        let currentUser = Parse.User.current();
        if(currentUser)
        {

        var query = new Parse.Query('Activity');       
        query.include("user");
        query.include("image");
        query.include("toUser");
        query.include("thumbnail");
        query.equalTo("type", "follow");
        query.equalTo("fromUser", currentUser);
        var self = this;
        
        query.find().then(function(result){
            if(result){
               let resultcount=result.length;
               let followingdataresult1 = [];

               if (resultcount > 0)
               {
                   let userdataresult1 = [];
                   self.setState({followingCount: resultcount});
                   self.setState({followingCountPopup: resultcount});
                   
                   for (var i = 0; i < resultcount; i++)
                   {
                     var user = result[i];
                    
                     let userimage='';
                     if(user.get("toUser").get("profilePictureSmall") && user.get("toUser").get("profilePictureSmall").url()!==undefined)
                     {
                         userimage=user.get("toUser").get("profilePictureSmall").url();
                     }
                     else{
                         userimage="/images/default_userpic0.png";
                     }     
                     userdataresult1.push({'id':user.get("toUser").id,'displayName':user.get("toUser").get("displayName"),'displayUsername':user.get("toUser").get("displayUsername"),'image':userimage,'fromUser':user.get("fromUser").id,});
                     followingdataresult1.push({'id':user.get("toUser").id,'name':user.get("toUser").id});
                     self.setState({followinguserid: followingdataresult1});   
                     self.setState({followingImages: userdataresult1});  
                     self.setState({searchfollowingListing: userdataresult1});                      
                    }
               }else{
                  self.setState({followingImages: []});  
                  self.setState({followingCount: 0});
                  self.setState({followinguserid: []});  
                  self.setState({followingCountPopup: 0});
               }
            }
        })

        //followingImages
        //followers
        var followersquery = new Parse.Query('Activity');       
        followersquery.include("user");        
        followersquery.include("fromUser");
        followersquery.include("image");
        followersquery.include("thumbnail");
        followersquery.equalTo("type", "follow");
        followersquery.equalTo("toUser", currentUser);
        var self = this;
        followersquery.find().then(function(followerresult){
            if(followerresult){
               let resultcount=followerresult.length;
               if (resultcount > 0)
               {
                      let userdataresult = [];
                      self.setState({followersCount: resultcount});
                      self.setState({followersCountPopup: resultcount});
                      
                      //self.setState({followersListing:'followerresult'});
                       for (var i = 0; i < resultcount; i++)
                        {
                            let Images=null;
                              var user = followerresult[i];
                              if(user.get("fromUser").get("profilePictureSmall") && user.get("fromUser").get("profilePictureSmall").url()!==undefined)
                              {
                                Images=user.get("fromUser").get("profilePictureSmall").url();
                              }
                              userdataresult.push({'id':user.get("fromUser").id,'displayName':user.get("fromUser").get("displayName"),'displayUsername':user.get("fromUser").get("displayUsername"),'image':Images,'toUser':user.get("toUser").id});
                              //self.setState({followersListing:resultcount});
                        }
                        self.setState({followersListing: userdataresult});
                        self.setState({searchfollowersListing:userdataresult});
                        
               }
            }
        })


       }
     }

    queryForUserData() {
        var query = new Parse.Query('User');      
        query.equalTo("displayUsername", this.usernameParam);
        // query.equalTo("displayUsername", 'cinnamonshtick');

        query.include("user");
        query.include("image");
        query.include("thumbnail");
        query.include("likeCountNew");
        query.include("saveCount");
        query.include("commentcount");
        query.include("_created_at");
        query.include("createdAt");
        query.include("recipe");
        query.include("product");
        query.include("collabUser");
        query.include("collabUser.displayUsername");
        query.ascending("name");

        var self = this;

        query.first().then(function(result){
            if(result){
                self.setState({userData: result}); 
                self.setState({user: result});
                let profilePictureSmall='';
                if (result.get("profilePictureSmall"))
               {
                   self.setState({userImage: result.get("profilePictureSmall").url()});
               }
                self.queryForPosts();
                self.queryForPostsSave();
                self.queryForPostsRecipe();
                self.queryForChallenges();
                self.queryGetFollowersFollowing();
            } else {
                console.log("No post found");
               // promise.resolve(null);
            }
        }, function(error){
                console.error("Error loading post Error: " + error);
                //promise.error(error);
        });
    }

    getWebsite()
    {
        var website = this.state.userData.get("website");

        if (!website)
            return "";
        else if (website.includes("http://"))
            return website;
        else if (website.includes("https://"))
            return website;
        else
            return "https://" + website;
    }
 updateTabValue = (newValue) => {
    /*var url = window.location.href;
    if(url.includes('my-profile'))
    {
      this.setState({ streampagepath: 'my-profile' });
    }*/
    //this.setState({ streamtabValue: newValue });
     localStorage.setItem('storestreamtabValue', newValue);
     
  };
    
    renderPosts()
    {
        
        let buffer = [];
        let savebuffer = [];
        let recipebuffer = [];
        let challengebuffer = [];
        let bufferfollowers=[];
        let bufferfollowing=[];

        var isPopupOpen= this.state.isPopupOpen;
        var postcommonid= this.state.post_common_id;
        var isNotificationOpen=this.state.isNotificationOpen; 
        var post_Notification_Ids=this.state.post_Notification_Id; 
        var post_Notification_Msg=this.state.post_Notification_Msg; 
        var post_Notification_Comment=this.state.post_Notification_Comment;

        const togglePopup = (postid) => {
        this.setState(prevState => ({
          isPopupOpen: !prevState.isPopupOpen,
        }));
        this.setState({ post_common_id: postid });
        
      };
      const streamid= (postid) =>{
           localStorage.setItem('storestreamid', postid);
      }
       
       /*new code*/
        let postRecord = [];
        if (this.state.posts)
        {
            for (var i = 0; i < this.state.posts.length; i++)
            {
                 var post = this.state.posts[i];  
                 let postdata_id=post && post.id;
                 let postdata_image=post && post.get("image") && post.get("image").url();

                // if(postdata_image) {
                 postRecord.push( 



                     <div className="gridPost" key={69*3*i}>
                                <a  id={postdata_id} href = "/stream" onClick={(e) => {streamid(postdata_id);}}>
                                <div className='chlng-icon'>                               
                                {post && post.get("isChallengeWinner") && post.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}                             
                                {post && post.get("isRecipe") && post.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img  src={postdata_image} />
                                    </figure>
                                </a>
                            </div>
                                    );  
            // }
            }

        }
        /*new code*/


        /*if (this.state.posts)
        {
           
            var rows = Math.floor(this.state.posts.length / 3) + 1;
            for (var i = 0; i < rows; i++)
            {
                
                var post = this.state.posts[i * 3];
                var post2 = this.state.posts[(i * 3)+1];
                var post3 = this.state.posts[(i * 3)+2];
                var post4 = this.state.posts[(i * 3)+3];               

               if ((post !== undefined   && post.get('image')) && 
                    (post2 !== undefined   && post2.get('image'))  && 
                    (post3 !== undefined   && post3.get('image')) 
                    )
                {
                    buffer.push(<div className="gridPostRow" key={69*i}>
 
                            <div className="gridPost" key={69*3*i}>

                                <a href={"/post/"+post.id}>

  
                             <div className='chlng-icon'>
                       
                                {post.get("isChallengeWinner") && post.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                             
                                {post.get("isRecipe") && post.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                   
                                    
                                    <figure className='thumbnail'>
                                        <img src={post.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                           
                                <a href={"/post/"+post2.id}>
                                 <div className='chlng-icon'>
                             
                                {post2.get("isChallengeWinner") && post2.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                           
                                {post2.get("isRecipe") && post2.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={post2.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                               <a href={"/post/"+post3.id}>
                                 <div className='chlng-icon'>
                             
                                {post3.get("isChallengeWinner") && post3.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                            
                                {post3.get("isRecipe") && post3.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={post3.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                        

                            </div>);
                }
                else if ((post != undefined) && (post.get("image")) &&
                    (post2 != undefined) && (post2.get("image")))
                {
                    buffer.push(<div className="gridPostRow" key={69*i}>

                            <div className="gridPost" key={69*3*i}>
                                <a href={"/post/"+post.id}>
                                  <div className='chlng-icon'>
                             
                                {post.get("isChallengeWinner") && post.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                             
                                {post.get("isRecipe") && post.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={post.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                               <a href={"/post/"+post2.id}>
                                 <div className='chlng-icon'>
                              
                                {post2.get("isChallengeWinner") && post2.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                              
                                {post2.get("isRecipe") && post2.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={post2.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>
                            </div>
                          

                            </div>);
                }
                else if ((post != undefined) && (post.get("image")))
                {
                    buffer.push(<div className="gridPostRow" key={69*i}>

                            <div className="gridPost" key={69*3*i}>
                                <a href={"/post/"+post.id}>
                                 <div className='chlng-icon'>
                           
                                {post.get("isChallengeWinner") && post.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                             
                                {post.get("isRecipe") && post.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img className="gridPost" src={post.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>                               
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>                               
                            </div>
                          

                            </div>);
                }
               
            }
        }*/
        /*if (this.state.saveposts)
        { 
          
            var savepostsrows =  Math.floor(this.state.saveposts.length / 3) + 1;
            
            for (var i = 0; i < savepostsrows; i++)
            { 
              
                var savepost =  this.state.saveposts[i * 3];
                var savepost2 = this.state.saveposts[(i * 3)+1];
                var savepost3 = this.state.saveposts[(i * 3)+2];
              
                 if ((savepost && savepost.get('photo') && savepost.get('photo')!=='undefined') && (savepost2 && savepost2.get('photo') && savepost2.get('photo')!=='undefined') && (savepost3 && savepost3.get('photo') && savepost3.get('photo')!=='undefined') ) 
                    
                {
                  
                    savebuffer.push(<div className="gridPostRow" key={69*i}>
 
                            <div className="gridPost" key={69*3*i}>
                          
                                <a   href={"/post/"+savepost.get('photo').id}>
                                  <div className='chlng-icon'>
                                {savepost.get('photo').get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                            
                                {savepost.get('photo').get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={savepost.get('photo').get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                          
                            <div className="gridPost" key={69*3*(i+1)}>
                               <a  href={"/post/"+savepost.get('photo').id} >
                                <div className='chlng-icon'>
                                {savepost2.get('photo').get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                             
                                 {savepost2.get('photo').get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={savepost2.get('photo').get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                             <a   href={"/post/"+savepost.get('photo').id}>
                              <div className='chlng-icon'>
                                {savepost3.get('photo').get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                           
                                 {savepost3.get('photo').get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={savepost3.get('photo').get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                         

                            </div>);
                }
                else if ((savepost && savepost.get('photo') && savepost.get('photo')!=='undefined') && (savepost2 && savepost2.get('photo') && savepost2.get('photo')!=='undefined'))
                {
                    savebuffer.push(<div className="gridPostRow" key={69*i}>

                            <div className="gridPost" key={69*3*i}>
                               <a   href={"/post/"+savepost.get('photo').id}>
                                 <div className='chlng-icon'>
                                {savepost.get('photo').get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                             
                                 {savepost.get('photo').get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={savepost.get('photo').get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                              <a    href={"/post/"+savepost.get('photo').id}>
                               <div className='chlng-icon'>
                                {savepost2.get('photo').get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                             
                                 {savepost2.get('photo').get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={savepost2.get('photo').get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>
                            </div>
                        

                            </div>);
                }
                else if ((savepost && savepost.get('photo') && savepost.get('photo')!=='undefined'))
                {
                   

                    savebuffer.push(<div className="gridPostRow" key={69*i}>
                            <div className="gridPost" key={69*3*i}>
                              <a   href={"/post/"+savepost.get('photo').id} >
                                <div className='chlng-icon'>
                                {savepost.get('photo').get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                                
                                {savepost.get('photo').get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img className="gridPost" src={savepost.get('photo').get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>                               
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>                               
                            </div>
                       
                            </div>);
                }
            }  
        }*/
        /*new code*/
        let saveRecord = [];
        if (this.state.saveposts)
        {
            for (var i = 0; i < this.state.saveposts.length; i++)
            {
                 var post = this.state.saveposts[i];  
                 let postdata_id=post.get('photo') && post.get('photo').id;
                 let postdata_image=post.get("photo") && post.get('photo').get("image").url();

                 if(postdata_image){


                 saveRecord.push( 

                     <div className="gridPost" key={69*3*i}>
                     {/*href={"/post/"+post.id} href = "javascript:void(0);"  onClick={(e) => {togglePopup(postdata_id);}}*/}
                                <a href = "/stream" id={postdata_id}  onClick={(e) => {streamid(postdata_id);}}>
                                <div className='chlng-icon'>                               
                                {post.get('photo') && post.get('photo').get("isChallengeWinner") && post.get('photo').get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}                             
                                {post.get('photo') && post.get('photo').get("isRecipe") && post.get('photo').get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img  src={postdata_image} />
                                    </figure>
                                </a>
                            </div>
                                    );  
             }

            }

        }
        /*new code*/

         /*new code*/
        let recipeRecord = [];
        if (this.state.recipeposts)
        {
            for (var i = 0; i < this.state.recipeposts.length; i++)
            {
                 var post = this.state.recipeposts[i];  
                 let postdata_id=post && post.id;
                 let postdata_image=post && post.get("image") && post.get("image").url();

                {/*href = "javascript:void(0);" id={postdata_id} onClick={(e) => {togglePopup(postdata_id);}}*/}
                 recipeRecord.push( 

                     <div className="gridPost" key={69*3*i}>
                                <a  href = "/stream" id={postdata_id}  onClick={(e) => {streamid(postdata_id);}}>
                                <div className='chlng-icon'>                               
                                {post && post.get("isChallengeWinner") && post.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}                             
                                {post && post.get("isRecipe") && post.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img  src={postdata_image} />
                                    </figure>
                                </a>
                            </div>
                                    );  
            }

        }
        /*new code*/

        if (this.state.recipeposts)
        { 
            
           
            var reciperows = Math.floor(this.state.recipeposts.length / 3) + 1;
            for (var i = 0; i < reciperows; i++)
            {
             
                var recipepost = this.state.recipeposts[i * 3];
                var recipepost2 = this.state.recipeposts[(i * 3)+1];
                var recipepost3 = this.state.recipeposts[(i * 3)+2];
                var recipepost4 = this.state.recipeposts[(i * 3)+3];

             if ((recipepost !== undefined   && recipepost.get('image')) && 
                    (recipepost2 !== undefined   && recipepost2.get('image'))  && 
                    (recipepost3 !== undefined   && recipepost3.get('image')) 
                    )
                {
                    recipebuffer.push(<div className="gridPostRow" key={69*i}>

                            <div className="gridPost" key={69*3*i}>
                             <a href={"/post/"+recipepost.id}>
                               <div className='chlng-icon'>
                                {recipepost.get("isChallengeWinner")!==undefined && recipepost.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                             
                                {recipepost.get("isRecipe")!==undefined && recipepost.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                               
                                    <figure className='thumbnail'>
                                        <img src={recipepost.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                                <a href={"/post/"+recipepost2.id}>
                                 <div className='chlng-icon'>
                                {recipepost2.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                            
                                {recipepost2.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={recipepost2.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                               <a href={"/post/"+recipepost3.id}>
                                  <div className='chlng-icon'>
                                {recipepost3.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                              
                                {recipepost3.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={recipepost3.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>  
                            </div>);
                }
                else if ((recipepost !== undefined  && recipepost.get('image'))  &&
                    (recipepost2!== undefined  && recipepost2.get('image')))
                {
                    recipebuffer.push(<div className="gridPostRow" key={69*i}>

                            <div className="gridPost" key={69*3*i}>
                              <a href={"/post/"+recipepost.id}>
                            <div className='chlng-icon'>
                                {recipepost.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                             
                                {recipepost.get("isRecipe")===true &&  <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                              
                                    <figure className='thumbnail'>
                                        <img src={recipepost.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                               <a href={"/post/"+recipepost2.id}>
                                <div className='chlng-icon'>
                                {recipepost2.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                             
                                {recipepost2.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img src={recipepost2.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>
                            </div>

                            </div>);
                }
                else if (recipepost !== undefined && recipepost.get('image'))
                {
                    recipebuffer.push(<div className="gridPostRow" key={69*i}>
                            <div className="gridPost" key={69*3*i}>
                                <a href={"/post/"+recipepost.id}>
                                  <div className='chlng-icon'>
                                {recipepost.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                            
                                {recipepost.get("isRecipe")===true && <div className='recipe'><img src="../images/recipe-icon-img.svg"/></div>}
                                 </div>
                                    <figure className='thumbnail'>
                                        <img className="gridPost" src={recipepost.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>                               
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>                               
                            </div>
                         
                            </div>);
                }
            }  
        }

        /*if (this.state.challenges)
        {
            var rows = Math.floor(this.state.challenges.length / 3) + 1;
            for (var i = 0; i < rows; i++)
            {
               
                var post = this.state.challenges[i * 3];
                var post2 = this.state.challenges[(i * 3)+1];
                var post3 = this.state.challenges[(i * 3)+2];
                var post4 = this.state.challenges[(i * 3)+3];               
              if ((post !== undefined   && post.get('image')) && 
                    (post2 !== undefined   && post2.get('image'))  && 
                    (post3 !== undefined   && post3.get('image')) 
                    )
                {
                    challengebuffer.push(<div className="gridPostRow" key={69*i}> 
 
                            <div className="gridPost" key={69*3*i}>
                                <a href={"/post/"+post.id}>
                                    <div className='chlng-icon'>
                                       
                                     {post.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                                    </div>
                                    <figure className='thumbnail'>
                                        <img src={post.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                                <a href={"/post/"+post2.id}>
                                    <div className='chlng-icon'>
                                      
                                    {post2.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                                   
                                    </div>
                                    <figure className='thumbnail'>
                                        <img src={post2.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                               <a href={"/post/"+post3.id}>
                                    <div className='chlng-icon'>
                                      
                                    {post3.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                                   
                                        
                                    </div>
                                    <figure className='thumbnail'>
                                        <img src={post3.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>

                            </div>);
                }
                else if ((post != undefined) && (post.get("image")) &&
                    (post2 != undefined) && (post2.get("image")))
                {
                    challengebuffer.push(<div className="gridPostRow" key={69*i}>

                            <div className="gridPost" key={69*3*i}>
                                <a href={"/post/"+post.id}>
                                    <div className='chlng-icon'>    
                                    
                                    {post.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                                    </div>
                                    <figure className='thumbnail'>
                                        <img src={post.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                               <a href={"/post/"+post2.id}>
                                    <div className='chlng-icon'>
                                     
                                    {post2.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                                    </div>
                                    <figure className='thumbnail'>
                                        <img src={post2.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>
                            </div>

                            </div>);
                }
                else if ((post != undefined) && (post.get("image")))
                {
                    challengebuffer.push(<div className="gridPostRow" key={69*i}>

                            <div className="gridPost" key={69*3*i}>
                                <a href={"/post/"+post.id}>
                                 <div className='chlng-icon'>    
                                   
                                 {post.get("isChallengeWinner")===true && <div className='winner'><img src="../images/winner-icon-img.svg"/></div>}
                                    
                                    </div>
                                    <figure className='thumbnail'>
                                        <img className="gridPost" src={post.get("image").url()}/>
                                    </figure>
                                </a>
                            </div>
                            <div className="gridPost" key={69*3*(i+1)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>                               
                            </div>
                            <div className="gridPost" key={69*3*(i+2)}>
                                <figure className='thumbnail'>
                                    <img className="gridPost" src="/images/emptygrid.png"/>
                                </figure>                               
                            </div>

                            </div>);
                }
               
            }
        }*/
        if(this.state.followersListing)
        {

            let followinguserid=this.state.followinguserid;
           
            var following_match_id=[];                    
            var rows = this.state.followersListing.length;
            if(rows != undefined){

                for (var i = 0; i < rows; i++)
                {
                   var followers = this.state.followersListing[i];
                   var follow_id_ms='followpopup_'+followers.id;

                   let userimage=null;
                   if(followers.image)
                   {
                       userimage=followers.image;
                   }else
                   {
                       userimage="/images/default_userpic0.png";
                   }
                    const currentUser = Parse.User.current();  
                    let   currentUserid=currentUser.id;
                     var chek = followinguserid.find(c =>{ return c.id === followers.id});//'K1iL8XNQOd'  
                     
                  
                    var followingresults= chek!=undefined?JSON.parse(JSON.stringify(chek)):""; 
                   
                   bufferfollowers.push(<div  className='items' key={69*i}>          
               
                                <div className='box follow-usr'>
                                  <div className="media">
                                    <div className="media-left">
                                  
                                    <img className="mr-3" src={userimage} alt="Generic placeholder image"/>
                            
                                    </div>
                                    <div className="media-body">
                                      <h5 className="m-0"><a href={'/user/'+followers.displayUsername}>{followers.displayName} </a></h5>
                                      <span>{followers.displayUsername}</span>
                                    </div>
                                  </div>
                                  <div className="action cta_btn">
                                   
                                   {/*   <a href="javascript:;" title="Follow">Follow</a>*/}
                                    {currentUserid===followers.id?"":followingresults.id===followers.id?<div className="fourth-btn btn-wrp"><a href="javascript:void(0);">Following</a></div>: <div className="third-btn btn-wrp"><a  id={follow_id_ms}  title={followers.toUser}   data-id={followers.id}       onClick={(e) => this.handleFollowMyProfile(e)}   style={{ display: "block" }}     href="javascript:void(0);"   className="followpost_linkpopup">Follow</a></div>}
                                  </div>
                                </div>                           
            </div>);
           }
            } 
        }
        if(this.state.followingImages)
        {
            
            var rows = this.state.followingImages.length;
           
            if(rows!=undefined || rows!=0){
                for (var i = 0; i < rows; i++)
                {
                   var followers = this.state.followingImages[i];
                   //console.log(followers.id+'followers.fromUser');
                   var follow_id_ms='followpopup_'+followers.id;
                   //'followpopup_'+followers.get("fromUser").id;

                   let userimage=null;
                   let currentUserid=null;
                   if(followers.image)
                   {
                       userimage=followers.image;
                   }else
                   {
                       userimage="/images/default_userpic0.png";
                   }
                   const currentUser = Parse.User.current();           
               /*if(currentUser)
               {  
                  currentUserid=currentUser.id;            
                  var checksavequery = new Parse.Query('Activity');  
                     checksavequery.equalTo('type', 'follow'); 
                    // checksavequery.equalTo('toUser', "_User$"+followers.get("fromUser").id);
                     checksavequery.equalTo('toUser', "_User$"+followers.id);
                     checksavequery.equalTo('fromUser',"_User$"+currentUserid);
                     checksavequery.find().then(function(resultAct){   
                     let activityresult=resultAct[0];   
                     if(activityresult)
                     { 
                        //$('#follwerModal a.unfollowpost_linkpopup#followpopup_'+followers.get("fromUser").id).attr("style", "display: block");
                       // $('#follwerModal a.followpost_linkpopup#followpopup_'+followers.get("fromUser").id).attr("style", "display: none");
                        $('#follwerModal a.followpost_linkpopup#followpopup_'+followers.id).attr("style", "display: none");
                     }
                    })
                      
               }*/
               if(followers.id){
                   bufferfollowing.push(<div  className='items' key={69*i}>          
               
                                <div className='box follow-usr'>
                                  <div className="media">
                                    <div className="media-left">
                                  
                                    <img className="mr-3" src={userimage} alt="Generic placeholder image"/>
                            
                                    </div>
                                    <div className="media-body">
                                      <h5 className="m-0"><a href={'/user/'+followers.displayUsername}>{followers.displayName}</a> </h5>
                                      <span>{followers.displayUsername}</span>
                                    </div>
                                  </div>
                                  <div className="action cta_btn">
                                    <div className="third-btn btn-wrp">
                                    {/*  <a href="javascript:;" title="Follow">Following</a>*/}
                                     <a id={follow_id_ms}  title="UnFollow"   data-id={followers.id}       onClick={(e) => this.handleUnFollowMyProfile(e)}   style={{ display: "block" }}     href="javascript:void(0);"   className="unfollowpost_linkpopup">Unfollow </a>
                                    </div>
                                  </div>
                                </div>
               
                           
            </div>);
               }
           }
            } 
        }
        return (
            <div className='post_grid-tab'>  {isNotificationOpen?<SaveNotification   isOpen={isNotificationOpen}  postNotificationid={post_Notification_Ids} postMsg={post_Notification_Msg} postPhotoid={post_Notification_Ids} postActivityComment={post_Notification_Comment}  />:""}  
            <CommonPopup   isOpen={isPopupOpen} onClose={(e) => {togglePopup(postcommonid);} } postcommonid={postcommonid} /> 
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                        <button className="nav-link active"   onClick={() => this.updateTabValue('posts')} id="posts-tab" data-toggle="tab" data-target="#posts" type="button" role="tab" aria-controls="posts" aria-selected="true">
                            <img className="gridPost def" src="/images/tab_prf_posts.svg" alt='posts'/>
                            <img className="gridPost act" src="/images/tab_prf_posts_actv.svg" alt='posts'/>
                            <span>posts</span>
                        </button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button className="nav-link" id="recipes-tab"  onClick={() => this.updateTabValue('recipes')}  data-toggle="tab" data-target="#recipes" type="button" role="tab" aria-controls="recipes" aria-selected="false">
                            <img className="gridPost def" src="/images/tab_prf_recipes.svg" alt='recipes'/>
                            <img className="gridPost act" src="/images/tab_prf_recipes_actv.svg" alt='recipes'/>
                            <span>recipes</span>
                        </button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button className="nav-link" id="saved-tab" data-toggle="tab" data-target="#saved"    onClick={() => this.updateTabValue('saved')}  type="button" role="tab" aria-controls="saved" aria-selected="false">
                            <img className="gridPost def" src="/images/tab_prf_bookmark.svg" alt='savedy'/>
                            <img className="gridPost act" src="/images/tab_prf_bookmark_actv.svg" alt='savedy'/>
                            <span>saved</span>
                        </button>
                    </li>
                    {/*<li className="nav-item" role="presentation">
                        <button className="nav-link" id="tagged-tab" data-toggle="tab" data-target="#tagged" type="button" role="tab" aria-controls="tagged" aria-selected="false">
                            <img className="gridPost def" src="/images/tab_prf_challenges.svg" alt='tagged'/>
                            <img className="gridPost act" src="/images/tab_prf_challenges_actv.svg" alt='tagged'/>
                            <span>challenges</span>
                        </button>
                    </li>*/}
                </ul>
                <div className="tab-content" id="myTabContent">
                    <div className="tab-pane fade show active" id="posts" role="tabpanel" aria-labelledby="posts-tab">
                        {/*buffer*/} <div className="gridPostRow">  {postRecord}  </div>
                    </div>
                    <div className="tab-pane fade" id="recipes" role="tabpanel" aria-labelledby="recipes-tab">
                        {/*recipebuffer*/}<div className="gridPostRow">   {recipeRecord}</div>
                    </div>
                    <div className="tab-pane fade" id="saved" role="tabpanel" aria-labelledby="saved-tab">
                        {/*savebuffer*/} <div className="gridPostRow">  {saveRecord} </div>
                        {/*{this.state.followersListing}*/}
                    </div>
                    {/*<div className="tab-pane fade" id="tagged" role="tabpanel" aria-labelledby="tagged-tab">
                        {challengebuffer}
                    </div>*/}
                </div>
                {/*post_common_idMyProfile*/}
              
                <div className="modal fade post_modal follwerModal" id="follwerModal" tabIndex="-1" role="dialog" data-backdrop="true" data-keyboard="true" aria-labelledby="createPostCloseTitle" aria-hidden="false">
                    {/* <div className='bg_overlay'></div> */}
                    <div className="modal-dialog modal-md modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className='inner text-center'>
                                    <div className='title-main'>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Modal">
                                        <img src="/images/back-arrow.svg" alt="Close"/>
                                        </button>
                                        <div className="search_wrap">
                                        <form className="form-mn d-flex flex-row flex-wrap">
                                            <input className="form-control" type="search" placeholder="Search" aria-label="Search"   value={this.state.searchTerm}
          onChange={this.handleSearch}/>
                                            <button type="submit"><img src="/images/search.svg" alt="Search"/></button>
                                        </form>
                                        </div>
                                    </div>
                                    <div className='tab-part'>
                                        <ul className="nav nav-tabs" id="usrfollwerTabs" role="tablist">
                                            <li className="nav-item">
                                                <a className="nav-link active" id="usrFlwrsTabs" data-toggle="tab" href="#usrFlwrsPane" role="tab" aria-controls="usrFlwrsPane" aria-selected="true"><strong>{/*this.state.followersCount*/}{this.state.followersCountPopup}</strong> Followers</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" id="usrFlwingTabs" data-toggle="tab" href="#usrFlwingPane" role="tab" aria-controls="usrFlwingPane" aria-selected="true"><strong>{/*this.state.followingCount*/}{this.state.followingCountPopup}</strong> Following</a>
                                            </li>
                                        </ul>
                                        <div className="tab-content" id="usrfollwerPanel">
                                            <div className="tab-pane fade show active" id="usrFlwrsPane" role="tabpanel" aria-labelledby="usrFlwrsTabs">
                                                <div className='list-wrap'>
                                                {bufferfollowers}                                        
                                                {/*<div className='items'>
                                                    <div className='box follow-usr'>
                                                    <div className="media">
                                                        <div className="media-left">
                                                        <img className="mr-3" src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/7690f2aef60cb3b9f6203a8bc4abdc2d_profilePicture.jpg" alt="Generic placeholder image"/>
                                                        </div>
                                                        <div className="media-body">
                                                        <h5 className="m-0">itsallgoodvegan</h5>
                                                        <span>Marissa Wong</span>
                                                        </div>
                                                    </div>
                                                    <div className="action cta_btn">
                                                        <div className="third-btn btn-wrp">
                                                        <a href="/edit-profile" title="Follow">Follow</a>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                                <div className='items'>
                                                    <div className='box follow-usr'>
                                                    <div className="media">
                                                        <div className="media-left">
                                                        <img className="mr-3" src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/7690f2aef60cb3b9f6203a8bc4abdc2d_profilePicture.jpg" alt="Generic placeholder image"/>
                                                        </div>
                                                        <div className="media-body">
                                                        <h5 className="m-0">itsallgoodvegan</h5>
                                                        <span>Marissa Wong</span>
                                                        </div>
                                                    </div>
                                                    <div className="action cta_btn">
                                                        <div className="third-btn btn-wrp">
                                                        <a href="/edit-profile" title="Follow">Follow</a>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                                <div className='items'>
                                                    <div className='box follow-usr'>
                                                    <div className="media">
                                                        <div className="media-left">
                                                        <img className="mr-3" src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/7690f2aef60cb3b9f6203a8bc4abdc2d_profilePicture.jpg" alt="Generic placeholder image"/>
                                                        </div>
                                                        <div className="media-body">
                                                        <h5 className="m-0">itsallgoodvegan</h5>
                                                        <span>Marissa Wong</span>
                                                        </div>
                                                    </div>
                                                    <div className="action cta_btn">
                                                        <div className="third-btn btn-wrp">
                                                        <a href="/edit-profile" title="Follow">Follow</a>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                                <div className='items'>
                                                    <div className='box follow-usr'>
                                                    <div className="media">
                                                        <div className="media-left">
                                                        <img className="mr-3" src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/7690f2aef60cb3b9f6203a8bc4abdc2d_profilePicture.jpg" alt="Generic placeholder image"/>
                                                        </div>
                                                        <div className="media-body">
                                                        <h5 className="m-0">itsallgoodvegan</h5>
                                                        <span>Marissa Wong</span>
                                                        </div>
                                                    </div>
                                                    <div className="action cta_btn">
                                                        <div className="third-btn btn-wrp">
                                                        <a href="/edit-profile" title="Follow">Follow</a>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                                <div className='items'>
                                                    <div className='box following-usr'>
                                                    <div className="media">
                                                        <div className="media-left">
                                                        <img className="mr-3" src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/7690f2aef60cb3b9f6203a8bc4abdc2d_profilePicture.jpg" alt="Generic placeholder image"/>
                                                        </div>
                                                        <div className="media-body">
                                                        <h5 className="m-0">itsallgoodvegan</h5>
                                                        <span>Marissa Wong</span>
                                                        </div>
                                                    </div>
                                                    <div className="action cta_btn">
                                                        <div className="third-btn btn-wrp">
                                                        <a href="/edit-profile" title="Follow">Following</a>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                                <div className='items'>
                                                    <div className='box following-usr'>
                                                    <div className="media">
                                                        <div className="media-left">
                                                        <img className="mr-3" src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/7690f2aef60cb3b9f6203a8bc4abdc2d_profilePicture.jpg" alt="Generic placeholder image"/>
                                                        </div>
                                                        <div className="media-body">
                                                        <h5 className="m-0">itsallgoodvegan</h5>
                                                        <span>Marissa Wong</span>
                                                        </div>
                                                    </div>
                                                    <div className="action cta_btn">
                                                        <div className="third-btn btn-wrp">
                                                        <a href="/edit-profile" title="Follow">Following</a>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                                <div className='items'>
                                                    <div className='box following-usr'>
                                                    <div className="media">
                                                        <div className="media-left">
                                                        <img className="mr-3" src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/7690f2aef60cb3b9f6203a8bc4abdc2d_profilePicture.jpg" alt="Generic placeholder image"/>
                                                        </div>
                                                        <div className="media-body">
                                                        <h5 className="m-0">itsallgoodvegan</h5>
                                                        <span>Marissa Wong</span>
                                                        </div>
                                                    </div>
                                                    <div className="action cta_btn">
                                                        <div className="third-btn btn-wrp">
                                                        <a href="/edit-profile" title="Follow">Following</a>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>*/}
                                                </div>
                                            </div>                                
                                            <div className="tab-pane fade" id="usrFlwingPane" role="tabpanel" aria-labelledby="usrFlwingTabs">
                                                <div className='list-wrap'>
                                                {bufferfollowing}
                                                {/*<div className='items'>
                                                    <div className='box following-usr'>
                                                    <div className="media">
                                                        <div className="media-left">
                                                        <img className="mr-3" src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/7690f2aef60cb3b9f6203a8bc4abdc2d_profilePicture.jpg" alt="Generic placeholder image"/>
                                                        </div>
                                                        <div className="media-body">
                                                        <h5 className="m-0">itsallgoodvegan</h5>
                                                        <span>Marissa Wong</span>
                                                        </div>
                                                    </div>
                                                    <div className="action cta_btn">
                                                        <div className="third-btn btn-wrp">
                                                        <a href="/edit-profile" title="Follow">Following</a>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                                <div className='items'>
                                                    <div className='box following-usr'>
                                                    <div className="media">
                                                        <div className="media-left">
                                                        <img className="mr-3" src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/7690f2aef60cb3b9f6203a8bc4abdc2d_profilePicture.jpg" alt="Generic placeholder image"/>
                                                        </div>
                                                        <div className="media-body">
                                                        <h5 className="m-0">itsallgoodvegan</h5>
                                                        <span>Marissa Wong</span>
                                                        </div>
                                                    </div>
                                                    <div className="action cta_btn">
                                                        <div className="third-btn btn-wrp">
                                                        <a href="/edit-profile" title="Follow">Following</a>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                                <div className='items'>
                                                    <div className='box following-usr'>
                                                    <div className="media">
                                                        <div className="media-left">
                                                        <img className="mr-3" src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/7690f2aef60cb3b9f6203a8bc4abdc2d_profilePicture.jpg" alt="Generic placeholder image"/>
                                                        </div>
                                                        <div className="media-body">
                                                        <h5 className="m-0">itsallgoodvegan</h5>
                                                        <span>Marissa Wong</span>
                                                        </div>
                                                    </div>
                                                    <div className="action cta_btn">
                                                        <div className="third-btn btn-wrp">
                                                        <a href="/edit-profile" title="Follow">Following</a>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>*/}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show"></div>
                </div>         
            </div>
        );
    }

    getImpressionCount() {
        if (this.state.userData.get("impr"))
            return this.state.userData.get("impr").toLocaleString(navigator.language, { minimumFractionDigits: 0 });
        else
            return 2;
    }
   

    renderProfileMain() {

        if (this.state.width <= 860)
        {
            return (
                <div className="porfile_card">
                    <div className="user_detail d-flex flex-row flex-wrap">
                        <div className="thumbnail">
                            {/* {this.state.userImage} */}
                                {this.state.userImage!==null?
                                    <img height="150" width="150" className="userProfileImageLarge"  src={this.state.userImage} alt="Profile Picture" />
                                    :<img height="150" width="150"  src="/images/default_userpic0.png" alt="Profile Picture" />
                                }
                             {/*   <img className="userProfileImageLargeDT" src={this.state.userImage}/>*/}
                        </div>
                        <div className="detail d-flex flex-column flex-wrap justify-content-center">
                            <div className='title-part d-flex flex-row flex-wrap align-items-center'>
                                <div className='name'>
                                    <h1>{this.state.userData.get("displayUsername")}</h1>
                                </div>
                            </div>
                        </div>
                        <div className='mobile_action'>
                            <div className="action cta_btn d-flex flex-row flex-wrap align-items-center justify-content-end">
                                <div className="fourth-btn btn-wrp">
                                    {this.state.getLoggedinUsername!=null?
                                    <a href="/edit-profile" title='Edit Profile'>Edit Profile</a>
                                    :''}
                                </div>
                            </div>
                        </div>
                        <div className='post-part'>
                            <ul>
                                <li>
                                    <div className='postcount'><strong>{this.state.postsCount}</strong>Posts</div>
                                </li>
                                <li>
                                    <div className='follwer'><a href="#usrFlwrsPane" type="button" data-toggle="modal" data-id="#usrFlwrsTabs"  onClick={this.checktabActive}  data-target="#follwerModal"><strong>{/*2,100*/}{this.state.followersCount}</strong>Followers</a></div>
                                </li>
                                <li>
                                    <div className='follwing'><a onClick={this.checktabActive}  href="#usrFlwingPane"  data-id="#usrFlwingTabs"  type="button" data-toggle="modal" data-target="#follwerModal"><strong>{/*390*/}{this.state.followingCount}</strong>Following</a></div>
                                </li>
                            </ul>
                        </div> 
                    </div>
                    <div className="bio_detail">
                        <p className='dname'>{this.state.userData.get("displayName")}</p>
                      {/*  <p>{this.state.userData.get("impr") ? this.state.userData.get("impr").toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : 2 } impressions</p>*/}
                        <p className='dbio'>{this.state.userData.get("bio")}</p>
                        <p className='web'><a href={this.getWebsite()}>{this.getWebsite()}</a></p>
                    </div>
                </div>
             );
        }
        else
        {
            return (
                <div className="porfile_card">
                    <div className="user_detail d-flex flex-row flex-wrap">
                        <div className="thumbnail">
                            {/* {this.state.userImage} */}
                                {this.state.userImage!==null?
                                    <img height="150" width="150" className="userProfileImageLarge"  src={this.state.userImage} alt="Profile Picture" />
                                    :<img height="150" width="150"  src="/images/default_userpic0.png" alt="Profile Picture" />
                                }
                             {/*   <img className="userProfileImageLargeDT" src={this.state.userImage}/>*/}
                        </div>
                        <div className="detail d-flex flex-column flex-wrap justify-content-center">
                            <div className='title-part d-flex flex-row flex-wrap align-items-center'>
                                <div className='name'>
                                    <h1>{this.state.userData.get("displayUsername")}</h1>
                                </div>
                                <div className="action cta_btn d-flex flex-row flex-wrap align-items-center justify-content-end">
                                    <div className="fourth-btn btn-wrp">
                                     {this.state.getLoggedinUsername!=null?
                                        <a href="/edit-profile" title='Edit Profile'>Edit Profile</a>
                                        :''}
                                    </div>
                                </div>
                            </div>
                            <div className='post-part'> 
                                <ul>
                                    <li>
                                        <div className='postcount'><strong>{this.state.postsCount}</strong>Posts</div>
                                    </li>
                                    <li>
                                        <div className='follwer'><a href="#usrFlwrsPane" type="button" data-toggle="modal" data-id="#usrFlwrsTabs"  onClick={this.checktabActive}  data-target="#follwerModal"><strong>{/*2,100*/}{this.state.followersCount}</strong>Followers</a></div>
                                    </li>
                                    <li>
                                        <div className='follwing'><a onClick={this.checktabActive}  href="#usrFlwingPane"  data-id="#usrFlwingTabs"  type="button" data-toggle="modal" data-target="#follwerModal"><strong>{/*390*/}{this.state.followingCount}</strong>Following</a></div>
                                    </li>
                                </ul>
                            </div>  
                            <div className="bio_detail">
                                <p className='dname'>{this.state.userData.get("displayName")}</p>
                                {/*  <p>{this.state.userData.get("impr") ? this.state.userData.get("impr").toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : 2 } impressions</p>*/}
                                <p className='dbio'>{this.state.userData.get("bio")}</p>
                                <p className='web'><a href={this.getWebsite()}>{this.getWebsite()}</a></p>
                            </div>
                        </div>
                    </div>
                    
                </div>
             );
        }
    }

    render() {

    var likesWord = "likes";
    var savesWord = "saves";
    var commentsWord = "comments";

    if (this.state.likeCount == 1) likesWord = "like";
    if (this.state.saveCount == 1) savesWord = "save";
    if (this.state.commentCount == 1) commentsWord = "comment";
    
    if (!this.state.userData)
    {
      return (
          <div>
          {/*User not found.*/}
          </div>

         );
    }
    return (
        
        <section className='post_list'>
            <div className='container'>
                <div className='inner'>
                    <nav className='sidebar'>
                        <Leftsidebar/>
                    </nav>
                    <main className='listing myprofile-listing'>
                        {this.renderProfileMain()}
                        {this.renderPosts()}
                    </main>                    
                </div>
            </div>
          {/*  <FooterStream tabValue={this.state.streamtabValue} pageValue={this.state.streampagepath} />*/}
           {/*  <input type="hidden" id="gridtabs" name="gridtabs" value={this.state.streamtabValue} />
             <input type="hidden" id="streampagepath" name="streampagepath" value={this.state.streampagepath} />*/}

         
        </section>

    );
  }
}

/*class Myprofiles extends React.Component {
    render() {
    return (
        <div className="App">
        <div className="mainProfileWrapper">
          <div className="mainProfileColumn">adaffa

         

            <center>


            </center>
          </div>
        </div>
       
         
        </div>

    );
  }
}*/

export default Myprofiles;



// WEBPACK FOOTER //
// ./src/user/Myprofile.jsx